export const formatNumberWithSpaces = (value: number | string | null) => {
  if (!value) return '-'

  // Convert value to string
  let formattedValue = value.toString()

  // Split value into integer and decimal parts
  const [integerPart, decimalPart] = formattedValue.split('.')

  // Format integer part
  const integerWithSpaces = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

  // Join integer part and decimal part (if exists) with a dot
  return decimalPart ? `${integerWithSpaces}.${decimalPart}` : integerWithSpaces
}

// Function to format a number with commas
export const formatNumberWithComma = (value: number | string | null) => {
  if (!value) return '-'

  // Convert value to string
  let formattedValue = value.toString()

  // Split value into integer and decimal parts
  const [integerPart, decimalPart] = formattedValue.split('.')

  // Format integer part
  const integerWithCommas = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  // Join integer part and decimal part (if exists) with a dot
  return decimalPart ? `${integerWithCommas}.${decimalPart}` : integerWithCommas
}

// Function to round to the nearest whole number and format it with commas
export const roundAndFormatWithComma = (value: number | string | null) => {
  if (!value) return '-'

  // Convert value to number and round it to the nearest whole number
  const roundedValue = Math.round(Number(value))

  // Format the rounded number with commas
  return formatNumberWithComma(roundedValue)
}

// Function to format a number with spaces and fixed decimal places
export const formatDecimalAndNumberWithSpaces = (value: number | string | null) => {
  if (!value) return '-' // Handle null or undefined values

  // Convert value to number and round it to 2 decimal places
  const roundedValue = Number(value).toFixed(2)

  // Split the value into integer and decimal parts
  const [integerPart, decimalPart] = roundedValue.split('.')

  // Format the integer part with spaces
  const integerWithSpaces = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

  // Format the decimal part to ensure it has two digits
  const formattedDecimalPart = (decimalPart || '00').slice(0, 2).padEnd(2, '0')

  // Join the formatted integer and decimal parts with a dot
  return `${integerWithSpaces}.${formattedDecimalPart}`
}

// Function to format a number with comma and fixed decimal places
export const formatDecimalAndNumberWithComma = (value: number | string | null, defaultValue: string = '-') => {
  if (!value) return defaultValue // Handle null or undefined values

  // Convert value to number and round it to 2 decimal places
  const roundedValue = Number(value).toFixed(2)

  // Split the value into integer and decimal parts
  const [integerPart, decimalPart] = roundedValue.split('.')

  // Format the integer part with spaces
  const integerWithSpaces = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  // Format the decimal part to ensure it has two digits
  const formattedDecimalPart = (decimalPart || '00').slice(0, 2).padEnd(2, '0')

  // Join the formatted integer and decimal parts with a dot
  return `${integerWithSpaces}.${formattedDecimalPart}`
}
